import React, {useState} from "react";
import {InputField} from "./InputField";
import {ClearChatHistoryModal} from "./ClearChatHistoryModal";
import {WidgetHeader} from "./WidgetHeader";
import {WidgetMessages} from "./WidgetMessages";
import {useAppSelector} from "../../app/hooks";
import {horizontalPositionSelector, isBotOpenSelector, isMobileSelector, WidgetPositionEnum} from "../chatbotSlice";
import {WidgetFooter} from "./WidgetFooter";

export const BotChatDialog: React.FC = () => {

    const isOpen = useAppSelector(isBotOpenSelector);
    const isMobile = useAppSelector(isMobileSelector);

    const [isClearChatHistoryModalOpen, setIsClearChatHistoryModalOpen] = useState(false);
    const widgetHorizontalPosition = useAppSelector(horizontalPositionSelector);
    const isRight = widgetHorizontalPosition === WidgetPositionEnum.RIGHT;
    const styles = isRight
        ? "sm:right-[35px] origin-bottom-right"
        : "sm:left-[35px]  origin-bottom-left";


    return <div
        className={`${styles} sm:bottom-11 bg-[#F8F8F8] fixed top-0 border-white sm:border-gray-300 
        ${isMobile ? "w-[100%] h-[100%]  rounded-t-2xl" : "mt-2 w-[96%] h-[96.5%] rounded-2xl sm:shadow-lg"} flex flex-col z-200 sm:w-[370px] transition-transform transform duration-300 ease-in-out ${
            isOpen ? "z-50 scale-100" : "scale-0"
        }`}
        onTouchStart={(e) => document.body.style.overflow = "hidden"}
        onTouchEnd={(e) => document.body.style.overflow = ""}
        style={{boxShadow: "0 0 8px 4px rgba(0, 18, 46, 0.16)"}}
    >
        <WidgetHeader setIsClearChatHistoryModalOpen={setIsClearChatHistoryModalOpen}/>
        <div
            className="h-full message-container flex-grow pt-3 pb-1 flex flex-col rounded-lg mb-1.5 mr-1.5 ml-1.5 text-sm relative shadow-black rounded-t-4xl rounded-b-4xl overflow-hidden sm:bg-[#ffffff] text-[#000000]">
            <ClearChatHistoryModal
                isOpen={isClearChatHistoryModalOpen}
                setIsOpen={setIsClearChatHistoryModalOpen}
            />
            <WidgetMessages/>
            <InputField/>
            <WidgetFooter/>
        </div>
    </div>
}
